import {
  getAllSubservicesApiRequest,
  getClassesApiRequest,
  getCoursesApiRequest,
  getEventsApiRequest,
  getOneTimeApiRequest,
} from '@guryou/api-client';
import {
  createOrderEventApiCall,
  getBookedEventsApiCall,
  getBookedEventsByProviderIdFromAdminApiCall,
  getCalendarEventsApiRequest,
  getOrderEventsApiCall,
  markOrderAsPaidApiCall,
} from '@guryou/api-client-gql';

import { Action, ActionStatus, buildActionType, executeApiCall } from '../core';
import {
  CALENDAR_EVENTS,
  CALENDAR_FILTER_GET_CLASSES,
  CALENDAR_FILTER_GET_COURSES,
  CALENDAR_FILTER_GET_EVENTS,
  CALENDAR_FILTER_GET_SERVICES,
  CALENDAR_FILTER_GET_SUBSERVICES,
  MARK_ORDER_AS_PAID,
  ORDER_EVENT_CREATE,
  ORDER_EVENTS,
} from '../types';

import { execute } from './actionWrapper';

export const RESERVATIONS_GET_CURRENT = { entity: 'BOOKED_EVENTS', action: Action.GET_MANY };

export const parseCalendarEventUser = event => {
  if (event.userInfo?.firstname && event.userInfo?.lastname) {
    return `${event.userInfo.firstname} ${event.userInfo.lastname}`;
  }

  if (event.userInfo?.firstname) {
    return event.userInfo.firstname;
  }

  if (event.userInfo?.lastname) {
    return event.userInfo.lastname;
  }

  if (event.user?.firstname && event.user?.lastname) {
    return `${event.user?.firstname} ${event.user?.lastname}`;
  }

  return null;
};

const getCalendarEvents = (startTime, endTime) => async dispatch =>
  execute(dispatch, () => getCalendarEventsApiRequest(startTime, endTime), CALENDAR_EVENTS);

const getCalendarFilterServices = silent => async dispatch =>
  dispatch(executeApiCall(getOneTimeApiRequest(), CALENDAR_FILTER_GET_SERVICES, silent, undefined, true));

const getCalendarFilterCourses = silent => async dispatch =>
  dispatch(executeApiCall(getCoursesApiRequest(), CALENDAR_FILTER_GET_COURSES, silent, undefined, true));

const getCalendarFilterEvents = silent => async dispatch =>
  dispatch(executeApiCall(getEventsApiRequest(), CALENDAR_FILTER_GET_EVENTS, silent, undefined, true));

const getCalendarFilterSubservices = (id, silent) => async dispatch =>
  dispatch(executeApiCall(getAllSubservicesApiRequest(id), CALENDAR_FILTER_GET_SUBSERVICES, silent, undefined, true));

const getCalendarFilterClasses = (id, silent) => async dispatch =>
  dispatch(executeApiCall(getClassesApiRequest(id), CALENDAR_FILTER_GET_CLASSES, silent, undefined, true));

const getOrderEvents = orderId => async dispatch => execute(dispatch, () => getOrderEventsApiCall({ orderId }), ORDER_EVENTS);

const createOrderEvent = request => async dispatch => execute(dispatch, () => createOrderEventApiCall({ request }), ORDER_EVENT_CREATE);

const markOrderAsPaid = id => async dispatch => execute(dispatch, () => markOrderAsPaidApiCall({ id }), MARK_ORDER_AS_PAID);

const resetCalendarFilters = () => async dispatch => {
  dispatch({ type: buildActionType(CALENDAR_EVENTS, ActionStatus.RESET) });
  dispatch({ type: buildActionType(CALENDAR_FILTER_GET_SERVICES, ActionStatus.RESET) });
  dispatch({ type: buildActionType(CALENDAR_FILTER_GET_COURSES, ActionStatus.RESET) });
  dispatch({ type: buildActionType(CALENDAR_FILTER_GET_EVENTS, ActionStatus.RESET) });
  dispatch({ type: buildActionType(CALENDAR_FILTER_GET_SUBSERVICES, ActionStatus.RESET) });
  dispatch({ type: buildActionType(CALENDAR_FILTER_GET_CLASSES, ActionStatus.RESET) });
};

const getBookedEvents =
  (data = {}, silent) =>
  async dispatch => {
    execute(
      dispatch,
      () =>
        getBookedEventsApiCall(
          {
            ...data,
            email: data.search || null,
            startTime: data.startTime,
            endTime: data.endTime,
            resourceId: +data.resourceId || null,
            entityType: data.entityType || null,
          },
          {
            user: ['id', 'name', 'firstname', 'lastname', 'email', 'phone'],
            users: ['id', 'name', 'firstname', 'lastname', 'email', 'phone'],
            resources: ['id', 'name'],
          }
        ),
      RESERVATIONS_GET_CURRENT,
      false,
      null,
      silent
    );
  };

const getBookedEventsByProviderIdFromAdmin =
  (data = {}, silent) =>
  async dispatch => {
    execute(
      dispatch,
      () =>
        getBookedEventsByProviderIdFromAdminApiCall(
          {
            ...data,
            providerId: data?.providerId,
            email: data.search || null,
            startTime: data.startTime || new Date().toISOString(),
            endTime: data.endTime || new Date().toISOString(),
            resourceId: +data.resourceId || null,
            entityType: data.entityType || null,
          },
          {
            user: ['id', 'name', 'firstname', 'lastname', 'email', 'phone'],
            users: ['id', 'name', 'firstname', 'lastname', 'email', 'phone'],
            resources: ['id', 'name'],
          }
        ),
      RESERVATIONS_GET_CURRENT,
      false,
      null,
      silent
    );
  };

export {
  createOrderEvent,
  getBookedEvents,
  getBookedEventsByProviderIdFromAdmin,
  getCalendarEvents,
  getCalendarFilterClasses,
  getCalendarFilterCourses,
  getCalendarFilterEvents,
  getCalendarFilterServices,
  getCalendarFilterSubservices,
  getOrderEvents,
  markOrderAsPaid,
  resetCalendarFilters,
};
